import { ComponentProps } from 'react';
import { MessagingInboxOrg } from '@wetags/messaging-inbox';
import { Optional } from 'ts-toolbelt/out/Object/Optional';
import { Photos } from '@frontend/photos';
import { Avatar, CircularAvatarGroup, AvatarProps } from '@frontend/design-system';

type AvatarSwitcherProps = Optional<ComponentProps<typeof Photos.ContactProfilePhoto>, 'personId'> & {
  groupAvatars?: AvatarProps[];
};

export const AvatarSwitcher = ({ personId, groupAvatars, ...rest }: AvatarSwitcherProps) => {
  const [groupMessagingEnabled] = MessagingInboxOrg.useWetag('group-messaging');

  if (groupMessagingEnabled && groupAvatars?.length) {
    return <CircularAvatarGroup avatars={groupAvatars} size={'small'} />;
  }

  if (!personId) {
    return <Avatar {...rest} />;
  }

  if (rest.disableClick && rest.onClick) {
    return (
      <div role='button' onClick={rest.onClick} style={{ cursor: 'pointer' }}>
        <Photos.ContactProfilePhoto personId={personId} {...rest} />
      </div>
    );
  }

  return <Photos.ContactProfilePhoto personId={personId} {...rest} />;
};
